<template>
  <v-card width="350">
    <v-col align="center">
      <h3 class="mt-5 mb-2" align="center">Паспорт гидротехнического сооружения</h3>

      <v-row v-if="properties">
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">ID объекта</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ properties.id }}</v-card-text>
        </v-col>
      </v-row>

      <v-row v-if="properties">
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Номер</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="number_"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Широта</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ latitude }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Долгота</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ longitude }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Наименование сооружения</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="name"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Назначение сооружения</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="purpose"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Водоисточник</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="water_source"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Тип сооружения</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              :items="passport_hydraulicstructuretype"
              v-model="hydraulic_structure_type_id"
              item-text="name"
              item-value="id"
              placeholder="Тип сооружения"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Задвижки</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="valves"
              type="number"
              step="1"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Шандоры</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="shandors"
              type="number"
              step="1"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Мосты</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="bridges"
              type="number"
              step="1"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Дюкеры</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="duckers"
              type="number"
              step="1"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Принадлежность</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              :items="passport_belonging"
              v-model="belonging_id"
              item-text="name"
              item-value="id"
              placeholder="Принадлежность"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Ввод в эксплуатацию</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu v-model="plantingDateMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="exploitation_year"
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  clearable
              ></v-text-field>
            </template>
            <v-date-picker-years min="1960" max="2024" v-model="exploitation_year" scrollable></v-date-picker-years>
          </v-menu>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Пропускной пункт</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="checkpoint"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Примечание</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="note"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Адм. район</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ district_name }}</v-card-text>
        </v-col>
      </v-row>

      <div class="mt-2">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-card-text class="text-end">
              <v-btn type="button" class="font-weight-bold" @click="saveClick"
              >Сохранить</v-btn
              >
            </v-card-text>
          </v-col>
          <v-col v-if="isDraw" cols="12" sm="6" justify="end">
            <v-card-text class="text-start"
            ><v-btn type="button" class="font-weight-bold" @click="clearData"
            >Очистить</v-btn
            ></v-card-text
            >
          </v-col>
          <v-col v-else cols="12" sm="6" justify="end">
            <v-card-text class="text-start"
            ><v-btn
              type="button"
              class="font-weight-bold"
              @click="deleteClick"
            >Удалить</v-btn
            ></v-card-text
            >
          </v-col>
        </v-row>
      </div>

      <v-row dense>
        <v-col>
          <v-btn
              color="warning"
              style="color: black"
              @click="$emit('open-appeal')"
          >Сообщить об ошибке</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import Vue from "vue";
import { URL_API } from "@/settings/apiConnect";

export default {
  name: "HydraulicstructurePassport",

  props: {
    saveWater: Function,
    deleteWater: Function,
    properties: Object,
    isDraw: Boolean
  },

  data() {
    return {
      plantingDateMenu: false,
      passport_hydraulicstructuretype: [],
      passport_belonging: [],

      number_: null,
      latitude: null,
      longitude: null,
      name: null,
      purpose: null,
      water_source: null,
      hydraulic_structure_type_id: null,
      valves: null,
      shandors: null,
      bridges: null,
      duckers: null,
      belonging_id: null,
      exploitation_year: null,
      checkpoint: null,
      note: null,
      district_id: null,
      hydraulicstructuretype: null,

      district_name: null,
    };
  },

  methods: {
    saveClick() {
      const data = {
        number_: this.number_,
        latitude: this.latitude,
        longitude: this.longitude,
        name: this.name,
        purpose: this.purpose,
        water_source: this.water_source,
        hydraulic_structure_type_id: this.hydraulic_structure_type_id,
        valves: this.valves,
        shandors: this.shandors,
        bridges: this.bridges,
        duckers: this.duckers,
        belonging_id: this.belonging_id,
        exploitation_year: this.exploitation_year,
        checkpoint: this.checkpoint,
        note: this.note,
        district_id: this.district_id,
        hydraulicstructuretype: this.hydraulicstructuretype
      };

      this.saveWater(data);
    },
    deleteClick() {
      this.deleteWater();
    },
    clearData() {
      this.number_ = null;
      this.latitude = null;
      this.longitude = null;
      this.name = null;
      this.purpose = null;
      this.water_source = null;
      this.hydraulic_structure_type_id = null;
      this.valves = null;
      this.shandors = null;
      this.bridges = null;
      this.duckers = null;
      this.belonging_id = null;
      this.exploitation_year = null;
      this.checkpoint = null;
      this.note = null;
      this.district_id = null;
      this.hydraulicstructuretype = null;
    },

  },

  async mounted() {
    let response = await Vue.axios.get(`${URL_API}hydraulicstructuretype`);
    this.passport_hydraulicstructuretype = response.data;
    let response2 = await Vue.axios.get(`${URL_API}belonging`);
    this.passport_belonging = response2.data;

    if (this.properties?.id) {
      response = await Vue.axios.get(
        `${URL_API}hydraulicstructure/view/${this.properties.id}`
      );
      const data = response.data;
      console.log("данные воды", data);
      this.number_ = data.number_;
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.name = data.name;
      this.purpose = data.purpose;
      this.water_source = data.water_source;
      this.hydraulic_structure_type_id = data.hydraulic_structure_type_id;
      this.valves = data.valves;
      this.shandors = data.shandors;
      this.bridges = data.bridges;
      this.duckers = data.duckers;
      this.belonging_id = data.belonging_id;
      this.exploitation_year = data.exploitation_year;
      this.checkpoint = data.checkpoint;
      this.note = data.note;
      this.district_id = data.district_id;
      this.hydraulicstructuretype = data.hydraulicstructuretype;

      if (this.district_id) {
        this.district_name = data.district.name;
      }
    }
  }
};
</script>

<style scoped>
::v-deep .v-input__slot {
  margin: 0;
  max-height: 32px;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
  height: 32px;
  font-size: 12px;
}

::v-deep input,
p,
.v-input,
.v-card__text,
.v-text-field >>> label {
  font-size: 12px;
}

::v-deep .v-card__text {
  padding: 0;
}

::v-deep .v-select__selections {
  flex-wrap: nowrap;
}

::v-deep .v-text-field {
  padding-top: 0;
}
</style>
